import Swal from 'sweetalert2/dist/sweetalert2.js';
import {
  block, unblock,
} from './blocker';

export default ({ title, html, callback = () => {} }) => {
  Swal.fire({
    title,
    html,
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonText: 'Sure!',
    showLoaderOnConfirm: true,
    allowOutsideClick: () => !Swal.isLoading(),
  }).then(async (result) => {
    if (result.isConfirmed) {
      block();
      callback();
      unblock();
    }
  });
};
